
import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";


import { GameImage } from '../Game/GameImage.jsx'
import ConfettiGenerator from "confetti-js";
import VelikiDobitakNotifikacija from "./VelikiDobitakNotifikacija.jsx";

export class Notifikacija extends React.Component {

    constructor(props) {
        super(props);

        this.state = { igre: null, initDone: false, notifikacije: null, focused: false, najava: true, noviDizajnNotifikacije: true };

        this.notificationTouchStart = this.notificationTouchStart.bind(this);
        this.notificationTouchMove = this.notificationTouchMove.bind(this);
        this.notificationTouchEnd = this.notificationTouchEnd.bind(this);
        this.getNotifikacije = this.getNotifikacije.bind(this);
        this.zatvori = this.zatvori.bind(this);
        this.getClassName = this.getClassName.bind(this);
        this.setGames = this.setGames.bind(this);
        this.getIconClassName = this.getIconClassName.bind(this);
        this.getDogadajClassName = this.getDogadajClassName.bind(this);
        this.changeFocus = this.changeFocus.bind(this);
        this.getDobitakVrijeme = this.getDobitakVrijeme.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn)]);

        this.gamesPromises = casino.utils.makeCancelablePromise(promises);
        this.gamesPromises.promise.then(this.setGames, function (reason) { });

        this.notificationDiv = React.createRef();
        this.audio = React.createRef();
    }

    setGames(data) {
        var [igre] = data;
        this.setState({
            igre: igre
        });
    }

    notificationTouchStart(event) {
        var notificationDiv = this.notificationDiv.current;

        var touch = event.targetTouches[0];
        this._start = touch.pageY;
        this._end = -1;
        notificationDiv.className = notificationDiv.className + " no-animation";
    }

    notificationTouchMove(event) {
        var notificationDiv = this.notificationDiv.current;

        var touch = event.targetTouches[0];
        this._end = touch.pageY;
        var diff = this._end - this._start;

        if (diff < 0) {
            notificationDiv.style.transform = 'translate3d(0,' + diff + 'px,0)';
        } else {
            notificationDiv.style.transform = 'translate3d(0,0,0)';
        }
        event.preventDefault();
    }
    notificationTouchEnd(event) {
        var notificationDiv = this.notificationDiv.current;

        notificationDiv.className = notificationDiv.className.replace("no-animation", "").trim();
        notificationDiv.style.transform = null;

        if (this._end != -1 && (this._end - this._start) < -15) {
            this.zatvori(true, false);
        }
    }
    componentDidMount() {
        if (!this.state.initDone) {
            setTimeout(() => {
                this.setState({ initDone: true })
            }, 750);
        }

        this._start = -1, this._end = -1;
        var notificationDiv = this.notificationDiv.current;

        // postavimo evente na prozor od igre
        notificationDiv.addEventListener('touchstart', this.notificationTouchStart, false);
        notificationDiv.addEventListener('touchmove', this.notificationTouchMove, false);
        notificationDiv.addEventListener('touchend', this.notificationTouchEnd, false);

        setTimeout(this.getNotifikacije, 1000);

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    componentWillUnmount() {
        var notificationDiv = this.notificationDiv.current;

        notificationDiv.removeEventListener('touchstart', this.notificationTouchStart);
        notificationDiv.removeEventListener('touchmove', this.notificationTouchMove);
        notificationDiv.removeEventListener('touchend', this.notificationTouchEnd);

        clearInterval(this.checker);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);

        this.gamesPromises.cancel();

        if (this.cf)
            this.cf.clear();
    }

    handleVisibilityChange() {
        if (document.hidden) {
            // Stranica u pozadini — pauziramo notifikacije polling
            clearInterval(this.checker);
        } else {
            // Stranica ponovno vidljiva — restartamo polling
            this.props.getNotifikacijeFn();
            this.checker = setInterval(this.props.getNotifikacijeFn, 10000);
        }
    }

    getNotifikacije() {
        this.props.getNotifikacijeFn();
        this.checker = setInterval(this.props.getNotifikacijeFn, 10000);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.focused && nextProps.notifikacije) { // ako user gleda ne radi nikaj
            var notifikacije = nextProps.notifikacije;//.filter(x => x.tipNotifikacije == 8 || x.tipNotifikacije == 1);

            var staraNotifikacijaID = this.state.notifikacije && this.state.notifikacije && this.state.notifikacije.length ? this.state.notifikacije[0].igracNotifikacijaID : 0;
            var novaNotifikacijaID = notifikacije && notifikacije.length ? notifikacije[0].igracNotifikacijaID : 0;
            var showNajava = staraNotifikacijaID != novaNotifikacijaID;

            this.setState({
                notifikacije: notifikacije,
                najava: showNajava
            });


            if (showNajava)
                setTimeout(() => this.setState({ najava: false }), 1000); // onaj efekt gdje se text "Počeo je event" zamjeni s domaćin-gost
            // else if (staraNotifikacijaID > 0)
            //     this.zatvori(false, false);

            if (notifikacije && notifikacije.length && notifikacije[0].tipNotifikacije == 8) {
                this.setState({ focused: true });
                if (!this.state.noviDizajnNotifikacije) {
                    this.audio.current.play();
                    this.cf = new ConfettiGenerator({ target: 'conffeti-canvas', max: 60, size: 2.5, clock: 40, props: ['square', 'triangle'], rotate: true });
                    this.cf.render();
                }
            }
        }
    }

    zatvori(procitana, jeKlikKladiSe) {
        clearTimeout(this.checker);

        if (this.audio.current) {
            this.audio.current.pause();
            this.audio.current.currentTime = 0;
        }

        // maknemo notifikacije
        var aktivnaNotifikacija = this.state.notifikacije[0];
        this.setState({ focused: false });

        aktivnaNotifikacija.jeProcitana = procitana;
        aktivnaNotifikacija.jeKlikKladiSe = jeKlikKladiSe;
        casino.repos.notifikacijeRepo.remove(aktivnaNotifikacija).then(this.getNotifikacije);

        if (this.cf)
            this.cf.clear();
    }
    getClassName() {
        var cssClass = "notifikacija";
        if (this.state.notifikacije && this.state.notifikacije.length && this.state.initDone && this.props.user)
            if (this.state.notifikacije[0].tipNotifikacije == 1)
                cssClass = "notifikacija active";
            else
                cssClass = "notifikacija notifikacija2 active";


        if (this.state.focused)
            cssClass += " focus";

        if (this.state.notifikacije && this.state.notifikacije.length && this.state.notifikacije[0].tipNotifikacije >= 100)
            cssClass += " casino-notifikacija";

        return cssClass;
    }
    getIconClassName() {
        if (this.state.notifikacije && this.state.notifikacije.length) {
            if (this.state.notifikacije[0].sport) {
                var icoName = this.state.notifikacije[0].sport.toLowerCase().replace("š", 's');
                return 'icon ico-' + icoName + ' ico-' + icoName + '-invert';
            }
        }

        return "icon";
    }
    getDogadajClassName() {
        return "notifikacija--header--dogadjaj" + (this.state.najava ? "" : " showTitle");
    }
    changeFocus() {
        this.setState({ focused: !this.state.focused });
    }
    getDobitakVrijeme(time) {
        var diff = (new Date() - new Date(time)) / 60 / 60 / 1000;

        if (diff < 0.5)
            return 'Upravo sada';

        if (diff < 2)
            return 'Prije sat vremena';

        if (diff < 6)
            return 'Prije nekoliko sati';

        // if (new Date().toLocaleDateString() == new Date(time).toLocaleDateString())
        //     return 'Danas';

        return 'Dok Vas nije bilo';
    }

    getDobitakIznos(iznosDobitka) {
        var guiValuta = "";
        if (new Date() > new Date('01/01/2023 00:00:01 AM')) {
            guiValuta = '€';
        } else {
            guiValuta = 'kn';
        }

        return `${casino.utils.numberToString(iznosDobitka)} ${guiValuta}`;
    }

    render() {

        let notifikacija = this.state.notifikacije && this.state.notifikacije.length && this.state.notifikacije[0];
        let tipNotifikacije = this.state.notifikacije && this.state.notifikacije.length && this.state.notifikacije[0].tipNotifikacije || 0;
        let vrstaDobitka = this.state.notifikacije && this.state.notifikacije.length && this.state.notifikacije[0].vrstaDobitka || 0;
        let igra = notifikacija && this.state.igre && (tipNotifikacije == 8 || tipNotifikacije == 9) && this.state.igre.filter(function (igra) { return igra.s == notifikacija.igraSifra })[0];

        if (this.props.igraOtvorena && tipNotifikacije != 9) {
            return null;
        }

        if (this.state.noviDizajnNotifikacije && (tipNotifikacije == 8 || tipNotifikacije == 9)) {
            return <VelikiDobitakNotifikacija
                notifikacija={notifikacija}
                tipNotifikacije={tipNotifikacije}
                vrstaDobitka={vrstaDobitka}
                igra={igra}
                brands={this.props.brands}
                onClose={() => this.zatvori(true, true)}
                routePrefix={this.props.routePrefix} >
            </VelikiDobitakNotifikacija>
        } else {

            return <div>
                <div className={this.getClassName()} ref={this.notificationDiv}>

                    <audio ref={this.audio}>
                        <source src="content/sounds/sound-win.mp3" type="audio/mpeg" />
                    </audio>

                    <div>
                        <canvas className="conffeti" id="conffeti-canvas"></canvas>


                        {/* nove notifikacije */}
                        {this.state.notifikacije && this.state.notifikacije && tipNotifikacije >= 100 && <div>
                            <div className="notifikacija--head">
                                {this.state.notifikacije && this.state.notifikacije && !this.state.notifikacije[0].inboxHtml && <div className="slika-casino">
                                    <img src={this.state.notifikacije[0].pushSlika}></img>
                                </div>}
                                <div className="content-casino">
                                    <div className="notifikacija--header">
                                        <div className="notifikacija--header--left" onClick={this.changeFocus}>
                                            <span className={this.getIconClassName()}></span>
                                        </div>
                                        <div className="notifikacija--header--right" onClick={() => { this.zatvori(true, false); }}>
                                            <span className="icon ico-close-big"></span>
                                        </div>
                                        <div className="notifikacija--header--dogadjaj">{this.state.notifikacije && this.state.notifikacije && this.state.notifikacije[0].naslov}</div>
                                    </div>
                                    <div className="notifikacija-body" dangerouslySetInnerHTML={{ __html: this.state.notifikacije[0].popHtml || this.state.notifikacije[0].pushText }} />
                                    <div className="notifikacija--content ctas" onClick={() => { this.changeFocus(); this.zatvori(true, false) }}>
                                        {this.state.notifikacije[0].ctAs && this.state.notifikacije[0].ctAs.map(y => <a key={y[1]} className={"cta " + y[0]} href={y[2]}>{y[1]}</a>)}
                                    </div>
                                </div>
                            </div>


                        </div>}


                        {/* uzivo ide */}
                        {tipNotifikacije == 1 && <div>
                            <div className="notifikacija--head">
                                <div className="notifikacija--header">
                                    <div className="notifikacija--header--left" onClick={this.changeFocus}>
                                        <span className={this.getIconClassName()}></span>
                                    </div>
                                    <div className="notifikacija--header--right" onClick={() => { this.zatvori(true, false); }}>
                                        <span className="icon ico-close-big"></span>
                                    </div>
                                    {this.state.notifikacije && this.state.notifikacije.length ?
                                        <div className={this.getDogadajClassName()} onClick={this.changeFocus}>
                                            <div>
                                                <span>Upravo započeo događaj</span>
                                            </div>
                                            <div>
                                                <span>{this.state.notifikacije[0].domacin}</span><span>-</span><span>{this.state.notifikacije[0].gost}</span>
                                            </div>
                                        </div> : null}

                                </div>

                                <div className="notifikacija--content" onClick={this.changeFocus}>
                                    Ne propusti klađenje uživo.
                                    <span className="notifikacija--content--show-more">...</span>
                                </div>
                            </div>
                            <div className="notifikacija--footer">
                                <a target="_blank" href="https://m.supersport.hr/uzivo" onClick={() => { this.zatvori(true, true); }}>Kladi se</a>
                                <button className="as-link" onClick={() => { this.zatvori(true, false); }}>Sakrij</button>
                            </div>

                        </div>}

                        {/* veliki dobitki */}
                        {tipNotifikacije == 8 && <div className="relative">


                            <div className="notifikacija--head clearfix">
                                <div className="notifikacija--header">
                                    <div className="notifikacija--header--left" onClick={this.changeFocus}>
                                        <span >{this.getDobitakVrijeme(notifikacija.vrijemeDobitka)}</span>
                                    </div>
                                    <div className="notifikacija--header--right" onClick={() => { this.zatvori(true, false); }}>
                                        <span className="icon ico-close-big"></span>
                                    </div>
                                </div>
                            </div>

                            {/* jackpot */}
                            {vrstaDobitka == 0 &&
                                <div>
                                    <div className="text-center">
                                        <img className="" style={{ marginBottom: '-75px' }} src="content/images/assets/notification-image-jackpot.png" height="200px" />
                                    </div>
                                    <div className="notifikacija--game--container text-center">
                                        <div className="image-container as-inline-block">
                                            <NavLink to={{
                                                pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(igra.n),
                                                query: {
                                                    game: casino.utils.normalizeString(igra.n),
                                                    from: (this.props.from || '')
                                                }
                                            }} onClick={() => { this.zatvori(true, true); casino.repos.eventRepo.create(53, 69); }} className={'game-link ' + (this.props.extraClass || '')}>
                                                <span className="icon image-hover-icon"></span>
                                            </NavLink>
                                            <NavLink to={{
                                                pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(igra.n),
                                                query: {
                                                    game: casino.utils.normalizeString(igra.n),
                                                    from: (this.props.from || '')
                                                }
                                            }} onClick={() => { this.zatvori(true, true); casino.repos.eventRepo.create(53, 69); }} className={'game-item ' + (this.props.extraClass || '')}>

                                                <GameImage igra={igra} brands={this.props.brands} showJackpot={false} routePrefix={this.props.routePrefix}></GameImage>
                                            </NavLink>
                                        </div>
                                        <div className="text-container text-left as-inline-block">
                                            <span className="text text-11">{notifikacija.igrac} je u igri</span><br />
                                            <NavLink to={{
                                                pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(igra.n),
                                                query: {
                                                    game: casino.utils.normalizeString(igra.n),
                                                    from: (this.props.from || '')
                                                }
                                            }} onClick={() => { this.zatvori(true, true); casino.repos.eventRepo.create(53, 69); }} className={'game-link ' + (this.props.extraClass || '')}>
                                                <span className="text text-10">'{notifikacija.igra}'</span><br />
                                            </NavLink>
                                            <span className="text text-11">osvojio <span className="jackpot-text">JACKPOT</span></span><br />
                                            <span className="text text-11">u iznosu od:</span>
                                        </div>
                                    </div>

                                    <div className="text-center margin-top-xsmall margin-bottom-small">
                                        <span className="text text-12">{this.getDobitakIznos(notifikacija.iznosDobitka)}</span><br />
                                        <span className="text text-13">Čestitamo!</span><br />
                                    </div>
                                </div>
                            }

                            {/* veliki dobitak */}
                            {vrstaDobitka == 1 &&
                                <div>

                                    <div className="text-center margin-top margin-bottom">
                                        <img src="content/images/assets/notification-image-bigwin.png" height="110px" />
                                    </div>

                                    <div className="notifikacija--game--container text-center">
                                        <div className="image-container as-inline-block">
                                            <NavLink to={{
                                                pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(igra.n),
                                                query: {
                                                    game: casino.utils.normalizeString(igra.n),
                                                    from: (this.props.from || '')
                                                }
                                            }} onClick={() => { this.zatvori(true, true); casino.repos.eventRepo.create(53, 69); }} className={'game-link ' + (this.props.extraClass || '')}>
                                                <span className="icon image-hover-icon"></span>
                                            </NavLink>
                                            <NavLink to={{
                                                pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(igra.n),
                                                query: {
                                                    game: casino.utils.normalizeString(igra.n),
                                                    from: (this.props.from || '')
                                                }
                                            }} onClick={() => { this.zatvori(true, true); casino.repos.eventRepo.create(53, 69); }} className={'game-item ' + (this.props.extraClass || '')}>

                                                <GameImage igra={igra} brands={this.props.brands} showJackpot={false} routePrefix={this.props.routePrefix}></GameImage>
                                            </NavLink>
                                        </div>
                                        <div className="text-container text-left as-inline-block">
                                            <span className="text text-11">{notifikacija.igrac} je u igri</span><br />
                                            <NavLink to={{
                                                pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(igra.n),
                                                query: {
                                                    game: casino.utils.normalizeString(igra.n),
                                                    from: (this.props.from || '')
                                                }
                                            }} onClick={() => { this.zatvori(true, true); casino.repos.eventRepo.create(53, 69); }} className={'game-link ' + (this.props.extraClass || '')}>
                                                <span className="text text-10">'{notifikacija.igra}'</span><br />
                                            </NavLink>
                                            <span className="text text-11">osvojio/la:</span><br />
                                        </div>
                                    </div>

                                    <div className="text-center margin-top-xsmall margin-bottom-small">
                                        <span className="text text-12">{this.getDobitakIznos(notifikacija.iznosDobitka)}</span><br />
                                        <span className="text text-13">Čestitamo!</span><br />
                                    </div>
                                </div>
                            }
                        </div>}
                    </div>
                </div>
            </div>
        }

    }
};





